export default {
  TYPE_TOGGLE: 'TYPE_TOGGLE',
  HEADER: 'HEADER',
  LOGIN: 'LOGIN',
  APP: 'APP',
  SCHOOL: 'SCHOOL',
  INTROSPECT: 'INTROSPECT',
  MESSAGE: 'MESSAGE',
  MASTER: 'MASTER',
  METADATA: 'METADATA',
  UI_STATE: 'UI_STATE',
  USER: 'USER',
  PAYMENT_APPLICATION_ID: 'PAYMENT_APPLICATION_ID',
  TRANSACTION: 'TRANSACTION',
  PARENTS: 'PARENTS',
  SERVICEPROVIDER: 'SERVICEPROVIDER',
  ENROLLED_PROGRAMS: 'ENROLLED_PROGRAMS',
  PRIOR_PROGRAMS: 'PRIOR_PROGRAMS',
  ENROLLMENT_SUMMARY: 'ENROLLMENT_SUMMARY',
  SURVEY_DATA: 'SURVEY_DATA',
}
